import styles from './Divider.module.scss';

type DividerProps = {
  spacing?: number;
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

const Divider = ({
  spacing,
  orientation = 'horizontal',
  className
}: DividerProps): React.JSX.Element => {
  const computedClassName = [
    orientation === 'horizontal' ? styles.horizontal : styles.vertical,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={computedClassName} style={{
      margin: orientation === 'horizontal' ? `${spacing}px 0` : `0 ${spacing}px`,
    }}/>
  );
};

export default Divider;
